// src/components/OnboardingLayout.js

import React from 'react';
import './SplashScreen.css'; // shared styles
import logo from '../logo.svg';
import { getRandomMessage } from '../utils/getSplashMessage';

export function OnboardingLayout({ children, splashMessage, splashMessageID, splashLines }) {
  return (
    <div className="full-screen-wrapper">
      <div className="centered-screen">
        <div className="layout-top logo-container">
          <h1 className="splash-title">{/* A/B test title */}
            <span className="line">{splashLines[0]}</span>
            <span className="line small-break">{splashLines[1]}</span>
            <span className="line large-inline">{`${splashLines[1]}`}</span>
          </h1>
          <img src={logo} alt="Stemstead Logo" className="logo-spin brand-logo" />
          <div className="splash-message">{splashMessage}</div> 
        </div>
        <div className="layout-bottom">
          <div className="layout-content">
            {children} 
          </div>
        </div>
      </div>
    </div>
  );
}
